<mat-expansion-panel
    *ngIf="isMode === 'edit' || isMode === 'view'"
    (opened)="expandPanel()"
    (closed)="collapsePanel()"
    togglePosition="before"
    class="expansion-panel external-panel_{{ index }}"
    [ngClass]="{ 'mat-expansion-panel-view': isMode === 'view' }"
    [class.has-error]="hasServerError"
    [expanded]="isMode === 'edit' ? panelOpenedState : false"
>
    <mat-expansion-panel-header
        data-automation="externalPointHeader"
        class="panel-override"
        collapsedHeight="74px"
        expandedHeight="48px"
    >
        <mat-panel-title class="point-title">
            <div data-automation="externalPointName" class="service-account-label">
                {{ 'external.point.external_point' | translate }}: {{ getServiceDeliveryPointDisplayLabels() || '-' }}
            </div>
        </mat-panel-title>

        <mat-panel-description class="service-account-panel-subtitle" data-automation="externalPointSubtitle">
            {{ getSubtitle() }}
        </mat-panel-description>
        <i *ngIf="isViewMode" (click)="onToggle()">
            <img
                data-automation="editExternalPointIcon"
                class="edit-icon"
                id="edit_panel_{{ index }}"
                src="../../../assets/svg/edit-new.svg"
                alt=""
            />
        </i>
    </mat-expansion-panel-header>
    <span class="edit-buttons-container">
        <ng-container *ngIf="!externalPoint?.id">
            <mat-icon
                *ngIf="isEditing && panelOpenedState"
                data-automation="externalPointTrashIcon"
                [class.delete-icon-enabled]="'true'"
                id="delete_panel_{{ stableKey }}"
                (click)="!externalPoint.id && onRemove($event)"
                >delete-outlined</mat-icon
            >
        </ng-container>
    </span>
    <div class="panel-override">
        <!-- EDIT -->
        <app-external-point-form
            *ngIf="isMode === 'edit'"
            [point]="externalPoint"
            [mode]="isMode"
            [index]="index"
            [stableKey]="stableKey"
            [localeConfig]="localeConfig"
            [providers]="dataProviders"
            [channels]="channels"
            [userLocale]="userLocale"
            [reportingIntervals]="reportingIntervals"
            [loading]="loading"
            [sdpDisplayLabelsByLocale]="sdpDisplayLabelsByLocale"
            [supportedLocales]="supportedLocales"
            [disableChannelFn]="disableNothing"
            (valueChange)="point = $event"
            [getServiceDeliveryPointDisplayLabels]="serviceDeliveryPointDisplayLabels"
            [getSelectedChannelLabel]="getSelectedChannelLabel()"
            (dataProviderChange)="handleDataProviderChange($event)"
            (channelChange)="handleChannelChange($event)"
            (formValidity)="handleFormValidity($event)"
            (sourceIdInput)="handleSourceIdInput($event)"
            (sourceIdPaste)="handleSourceIdPaste($event)"
            (sourceIdBlur)="handleSourceIdBlur($event)"
            (formChange)="handleFormChange($event)"
            (panelOpenedChanged)="panelOpenedState = $event"
        >
        </app-external-point-form>

        <!-- VIEW -->
        <ng-container *ngIf="isMode === 'view'">
            <div class="view-details-container">
                <div class="detail-row">
                    <mat-label data-automation="pointNameLabel" class="field-label">
                        {{ 'sdp.list.table.heading.name' | translate }}:
                    </mat-label>
                    <span data-automation="pointNameValue" class="detail-value">{{
                        getServiceDeliveryPointDisplayLabels() || '-'
                    }}</span>
                </div>
                <div class="detail-row">
                    <mat-label data-automation="dataProviderLabel" class="field-label">
                        {{ 'external.point.data_provider' | translate }}:
                    </mat-label>
                    <span data-automation="dataProviderValue" class="detail-value">{{ getDataProviderLabel() }}</span>
                </div>
                <div class="detail-row">
                    <mat-label class="field-label">{{ 'external.point.source_id' | translate }}:</mat-label>
                    <span data-automation="sourceIdValue" class="detail-value">
                        {{ sourceIdLabel }}
                    </span>
                </div>
                <div class="detail-row">
                    <mat-label class="field-label">{{ 'external.point.channel' | translate }}:</mat-label>
                    <span data-automation="channelValue" class="detail-value">
                        {{ getSelectedChannelLabel() }}
                    </span>
                </div>
                <div class="detail-row">
                    <mat-label class="field-label">{{ 'external.point.reporting_interval' | translate }}:</mat-label>
                    <span data-automation="reportingIntervalValue" class="detail-value">
                        {{ getBaselinePointReportingIntervalLabel() }}
                    </span>
                </div>
                <div class="detail-row">
                    <mat-label class="field-label">{{ 'external.point.vee_bypass' | translate }}:</mat-label>
                    <span data-automation="veeBypassValue" class="detail-value">
                        {{ externalPoint.veeBypass ? 'Yes' : 'No' }}
                    </span>
                </div>
            </div>
        </ng-container>
    </div>
</mat-expansion-panel>
